import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog'; // MatDialogRef injected
import { PublicReviewDialog } from './public-review-dialog.component';
import { ConfigService } from '../config.service';
import { AppStateService } from '../app-state.service';
import { FormConfigService } from '../registration/forms-config.service';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-patient-review',
  templateUrl: './patient-review.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    HeaderComponent,
    MatProgressSpinnerModule,
  ],
  styleUrls: ['./patient-review.component.scss']
})
export class PatientReviewComponent {

  appStateService = inject(AppStateService);
  configService = inject(ConfigService);
  appConfig: any;
  orgId = '';
  clientId = '';
  patientId = '';
  deepLinkData: any;
  tokenInfo: any;
  appointment_datetime: '';
  reviewLinks: any = {};
  loading = false;  // Controls the loading state of the form
  submitted = false; // Controls whether to show the form or thank you message

  // Review form group
  reviewForm = new FormGroup({
    rating: new FormControl<number | null>(null, [Validators.required]),
    comment: new FormControl<string | null>(null)
  });

  formConfigService = inject(FormConfigService);

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    const state = this.appStateService.getState();
    this.appConfig = this.configService.getConfigData();
    this.orgId = state.orgId || '';
    this.clientId = state.clientId || '';
    this.patientId = state.patientId || '';
    this.deepLinkData = state.deeplinkData || {};
    this.tokenInfo = state.deeplinkData.tokenInfo || {};
    this.appointment_datetime = this.tokenInfo.appointment_datetime || '';
  }

  ngOnInit(): void {
    this.formConfigService.getClientConfig(this.clientId, 'review_links')
      .subscribe({
        next: (configData: any) => {
          this.reviewLinks = configData;
        },
        error: (error: any) => {
        }
      });
  }

  // Method to handle star rating click
  setRating(star: number) {
    this.reviewForm.patchValue({ rating: star });
  }

  // Method to handle form submission
  onSubmit() {
    if (this.reviewForm.valid) {
      const reviewData = {
        patientId: this.patientId,
        appointment_datetime: this.appointment_datetime,
        rating: this.reviewForm.value.rating,
        comment: this.reviewForm.value.comment,
        clientId: this.clientId,
        orgId: this.orgId,
      };
      this.loading = true;

      // POST the review to the backend
      this.formConfigService.postReview(this.clientId, this.patientId, reviewData)
        .subscribe({
          next: () => {
            this.snackBar.open('Review submitted successfully!', 'Close', { duration: 3000 });
            this.loading = false;
            this.submitted = true; // Set submitted flag to true to show thank you message

            // Handle public review prompt
            if (this.reviewForm.value.rating && this.reviewForm.value.rating >= 4) {
              this.openReviewDialog();  // Optionally open the public review dialog
            }
          },
          error: () => {
            this.loading = false;
            this.snackBar.open('Failed to submit review!', 'Close', { duration: 3000 });
          }
        });
    } else {
      this.snackBar.open('Please provide a rating!', 'Close', { duration: 3000 });
    }
  }

  // Method to open the dialog for public review suggestion
  openReviewDialog() {
    const dialogRef = this.dialog.open(PublicReviewDialog, {
      data: this.reviewLinks
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window.open(result, '_blank');
      }
    });
  }
}
